import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Send, Linkedin} from 'lucide-react';
import Logo from './Logo';

// X (Twitter) brand icon (Simple Icons path), using currentColor for fill
const XBrandIcon = ({ size = 20, className = '' }) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    className={className}
    fill="currentColor"
  >
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.798L0 1.154h7.594l5.243 6.932ZM17.6 21.138h2.094L7.033 4.12H4.938z" />
  </svg>
);


const Footer = () => {
  return (
    <footer className="bg-black text-gray-400 border-t border-[#10dfb2]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-2">
            <div style={{ width: 'fit-content', maxHeight: '100px', overflow: 'hidden' }}>
              <Logo className="h-20 w-auto" style={{ marginTop: '-10px', marginBottom: '-10px' }} />
            </div>
            <p className="text-sm">
              Empowering traders globally to trade with institutional capital.
              Global proprietary trading firm.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://x.com/i/flow/login?redirect_after_login=%2Ffunded_lab%2Fbio"
                className="hover:text-[#10dfb2] transition-colors"
                aria-label="X (Twitter)"
              >
                <XBrandIcon size={30} />
              </a>
              <a
                href="#"
                className="hover:text-[#10dfb2] transition-colors"
                aria-label="Send"
              >
                <Send size={30} />
              </a>
              <a
                href="https://www.instagram.com/fundedlab_propfirm/"
                className="hover:text-[#10dfb2] transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={30} />
              </a>
              <a
                href="https://www.linkedin.com/authwall?trk=gf&trkInfo=AQEBhBteempw8wAAAZp0sv6YH-NE3r397VrBN45y2571iz9WMXm1d2YdGvTtEWDjvQRghusm0Ng7atCytHw9tvbG3-24BKjnmO0d7MLSMXgierpx070Yqr71TG1sCWlraMvl9WU=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Ffunded-lab-210843398"
                className="hover:text-[#10dfb2] transition-colors"
                aria-label="Linkedin"
              >
                <Linkedin size={30} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/get-funded" className="hover:text-[#10dfb2] transition-colors">
                  Get Funded
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-[#10dfb2] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-[#10dfb2] transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/lab-partners" className="hover:text-[#10dfb2] transition-colors">
                  Lab Partners 
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="hover:text-[#10dfb2] transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <a href="mailto:support@thefundedlab.com" className="hover:text-[#10dfb2] transition-colors">
                  support@thefundedlab.com
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://dashboardanalytix.com/client-terms-and-policies/?v=0b3b97fa6688" className="hover:text-[#10dfb2] transition-colors">
                  Terms and Conditions
                </a>
              </li>
              <li>
                <a href="https://dashboardanalytix.com/purchases-and-refunds/?v=959848ca10cc" className="hover:text-[#10dfb2] transition-colors">
                  Refund Policy
                </a>
              </li>
              <li>
                <a href="https://dashboardanalytix.com/privacy-policy-3/?v=959848ca10cc" className="hover:text-[#10dfb2] transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="https://dashboardanalytix.com/cookie-policy/?v=959848ca10cc" className="hover:text-[#10dfb2] transition-colors">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#10dfb2]/20 mt-12 pt-8">
          <div className="text-center text-xs text-gray-500 mb-6 leading-relaxed max-w-4xl mx-auto px-4">
            <p className="font-semibold text-gray-400 mb-2">DISCLAIMER:</p>
            <p>FUNDED LAB is an affiliate of Prop Account, LLC. All funding assessments are provided by Prop Account, LLC and all assessment fees are paid to Prop Account, LLC. If you qualify for a Funded Account, you will be required to enter into a Trader Agreement with Prop Account LC. Neither Prop Account, LLC nor Prop Account LC provides any trading education or other services. All such services are provided by FUNDED LAB</p>
          </div>
          <div className="border-t border-[#10dfb2]/20 pt-8 text-center text-sm">
            <p>&copy; 2025 FundedLab. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
